import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { FC, useState } from 'react';

import {} from '../../../../../fetch';
import { IStandardFeatureOption } from '../../../../../models';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface IStandardFeaturesDropdown {
  handleChange: (value: number) => void;
  name: string;
  options: IStandardFeatureOption[];
  isLoading: boolean;
  selected: number[];
}
export const StandardFeaturesDropdown: FC<IStandardFeaturesDropdown> = ({
  handleChange,
  name,
  options,
  isLoading,
  selected
}) => {
  const [dropdownValue, setDropdownValue] = useState<number>(
    options.find(option => selected?.includes(option?.id))?.id
  );

  const classes = useStyles();

  return (
    <div key={name}>
      <FormControl className={classes.dropdown} fullWidth variant="outlined" size="small">
        <InputLabel id={`standardFeature-${name}`}>{isLoading ? 'Loading...' : name}</InputLabel>
        <Select
          disabled={isLoading}
          name={`standardFeature-${name}`}
          labelId={`standardFeature-${name}`}
          id={`standardFeature-${name}`}
          value={dropdownValue}
          size="small"
          onChange={({ target: { value } }) => {
            // Need to call this twice. The first call removes the currently selected item, the second adds the new item.
            dropdownValue && handleChange(+dropdownValue);
            handleChange(+value);
            setDropdownValue(+value);
          }}
        >
          {!isLoading && options.length === 0 && <MenuItem disabled>No data available</MenuItem>}
          {options.map(option => {
            return (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
};
const useStyles = makeStyles((theme: Theme) => ({
  dropdown: {
    margin: theme.spacing(1),
    paddingRight: theme.spacing(2)
  }
}));
